import axiosInstance from 'utils/axiosInstance';
import { appUrls } from 'constants/urls';
import { convertJalaiToMiladi } from 'utils/date-utils';

export const HypoInfoApi = async (patientId, daysAgo) => {
  const { data } = await axiosInstance.get(
    appUrls.hypoData(patientId, daysAgo)
  );
  return data;
};

export const HypoInfoListApi = async (patientId, daysAgo) => {
  let LogData = await axiosInstance.get(
    appUrls.hypoListData(patientId, daysAgo, 2)
  );
  console.log(LogData);
  return LogData?.data;
};

export const customDateHypo = async ({ patientId, date }) => {
  const { from, to } = date || {};
  const { data } = await axiosInstance.get(
    appUrls.hypoDataCustomDate(
      patientId,
      convertJalaiToMiladi(from),
      convertJalaiToMiladi(to)
    )
  );
  return data;
};

export const customDateHypoList = async ({ patientId, date }) => {
  const { from, to } = date || {};
  const { data } = await axiosInstance.get(
    appUrls.HypoListCustomDate(
      patientId,
      convertJalaiToMiladi(from),
      convertJalaiToMiladi(to)
    )
  );
  return data;
};
